module.exports = __webpack_public_path__ + "media/1x1/kn-4ad12564.svg";